"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validatePostMailSignatureDpi = exports.computePostMailSignatureEffectiveDpi = exports.POST_MAIL_SIGNATURE_MIN_DPI = exports.POST_MAIL_SIGNATURE_SLOT_HEIGHT_PX = exports.POST_MAIL_SIGNATURE_SLOT_WIDTH_PX = void 0;
// Signature slot on the PCM letter template (8.5" × 11" page, 96 DPI reference — see postMailLivePreviewLayoutConstants).
exports.POST_MAIL_SIGNATURE_SLOT_WIDTH_PX = 280;
exports.POST_MAIL_SIGNATURE_SLOT_HEIGHT_PX = 100.8;
// Minimum effective DPI when the image is fitted with object-fit: contain inside the slot.
exports.POST_MAIL_SIGNATURE_MIN_DPI = 200;
const computePostMailSignatureEffectiveDpi = (widthPx, heightPx) => Math.floor(Math.max((96 * widthPx) / exports.POST_MAIL_SIGNATURE_SLOT_WIDTH_PX, (96 * heightPx) / exports.POST_MAIL_SIGNATURE_SLOT_HEIGHT_PX));
exports.computePostMailSignatureEffectiveDpi = computePostMailSignatureEffectiveDpi;
const validatePostMailSignatureDpi = (widthPx, heightPx) => {
    const effectiveDpi = (0, exports.computePostMailSignatureEffectiveDpi)(widthPx, heightPx);
    if (effectiveDpi < exports.POST_MAIL_SIGNATURE_MIN_DPI) {
        return { status: "rejected", effectiveDpi };
    }
    return { status: "ok", effectiveDpi };
};
exports.validatePostMailSignatureDpi = validatePostMailSignatureDpi;
